import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Job } from '../../jobs.models';
import { JobsResource } from '../../resources/jobs.resource';
import { NotifyService } from '../../../common/services/notify.service';

@Component({
  selector: 'job-errors',
  template: `
    <div class="job-errors job-content">
      <pre *ngIf="jobLogBody">{{ jobLogBody }}</pre>
    </div>
  `,
})
export class JobErrorsComponent implements OnInit, OnChanges {
  @Input() item: Job;
  jobLogBody: string;

  constructor(private jobsResource: JobsResource, private notify: NotifyService, private translate: TranslateService) {}

  ngOnInit() {
    this.jobsResource.log(this.item.id).subscribe({
      next: (jobLog) => {
        this.jobLogBody = jobLog.body;
        if (this.jobLogBody === '') {
          this.jobLogBody = this.item.errors;
        }
      },
      error: (error) => {
        this.notify.error(this.translate.instant(`response.${error.status}.message`));
      },
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.item && changes.item.currentValue) {
      if (this.item.errors && this.jobLogBody === '') {
        this.jobLogBody = this.item.errors;
      }
    }
  }
}
